<template>
  <vue-dropzone
    @vdropzone-file-added="fileAdded"
    @vdropzone-drag-over="dragOver"
    @vdropzone-drag-leave="dragLeave"
    @vdropzone-error="error"
    ref="myVueDropzone"
    id="dropzone"
    :options="dropzoneOptions"
    @vdropzone-queue-complete="afterComplete"
    :useCustomSlot="true"
    :include-styling="!transparent"
    :class="bgColor"
  >
    <slot></slot>
  </vue-dropzone>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import { TokenService } from '@/services/storage.service'

export default {
  name: 'DropUpload',
  props: {
    filename: String,
    uploadWhere: String,
	newsletterFolder: String,
    gallery: String,
    exhibitionID: Number,
    photoshootID: Number,
    transparent: Boolean,
    maxFiles: Number,
    clickable: false,
    newsletter: '',
    date: '',
    acceptedFiles: {
      type: String,
      default: 'image/png,image/jpeg,.jpg,.jpeg,image/psd,.psd'
    },
    maxFileSize: {
      type: Number,
      default: 40.0
    }
  },
  components: {
    vueDropzone: vue2Dropzone
  },
  methods: {
    afterComplete (file) {
      this.$emit('uploadComplete', file)
      this.$refs.myVueDropzone.removeAllFiles()
    },
    dragOver (event) {
      this.bgColor = 'elevation-24'
    },
    error (event) {
      alert(JSON.stringify(event))
    },
    dragLeave (event) {
      this.bgColor = 'white'
    },
    fileAdded (file) {
      this.dropzoneOptions.params.gallery = this.gallery
      this.dropzoneOptions.params.exhibitionID = this.exhibitionID
      this.dropzoneOptions.params.photoshootID = this.photoshootID
	  this.dropzoneOptions.params.newsletterFolder = this.newsletterFolder

      if (this.newsletter !== '') {
        this.dropzoneOptions.params.newsletter = this.newsletter
      }
      if (this.date !== '') {
        this.dropzoneOptions.params.date = this.date
      }
    }
  },
  data: function () {
    return {
      bgColor: 'white',
      dropzoneOptions: {
        url: process.env.VUE_APP_WEBSITE + '/memberlogin2/upload2.php?JSON=true&uploadWhere=' + this.uploadWhere + '&rnd=' + Math.random(),
        thumbnailWidth: 200,
        maxFilesize: this.maxFileSize,
        maxFiles: this.maxFiles,
        clickable: this.clickable,
        acceptedFiles: this.acceptedFiles,
        params: {
          'Username': TokenService.getUsername(),
          'token': TokenService.getToken()
        },
        paramName: 'Filedata[]',
        parallelUploads: 1
      }
    }
  }
}
</script>
